<template>
  <div class="py-8" v-if="loading">
    <loading />
  </div>
  <div v-else-if="searchVisible">
    <div class="p-4 pb-0">
      <info toggleable :title="$t('users.add_friend')">{{ $t('users.add_friend_info_message') }}</info>
    </div>
    <div class="grid grid-cols-1-auto gap-2 p-4">
      <input-text
        :label="$t('general.username')"
        @update-value="updateForm('search', $event)"
        @enter-key="submit(formOptions)"
      />
      <div class="flex items-end mb-1">
        <wd-button @input="submit(formOptions)">{{ $t("general.search") }}</wd-button>
      </div>
    </div>
    <div>
      <friend v-for="user in searchResult" :key="user.id" :friend="user" />
    </div>
  </div>
  <div class="h-full" v-else>
    <div
      v-if="
        (incomingFriendRequests && incomingFriendRequests.length > 0) ||
          (outgoingFriendRequests && outgoingFriendRequests.length > 0) ||
          (friends && friends.length > 0)
      "
    >
      <friend
        v-for="friendRequest in incomingFriendRequests"
        :key="friendRequest.id"
        :friend="friendRequest.user"
        :friend-request="friendRequest"
      />
      <friend
        v-for="friend in friends"
        :key="friend.id"
        :friend="friend"
        :checkbox="select"
        :checked="friend.checked"
        @input="storeFriend"
      />
      <friend
        v-for="friendRequest in outgoingFriendRequests"
        :key="friendRequest.id"
        :friend="friendRequest.user"
        pending
      />
    </div>
    <div class="h-full p-8 stack grid content-center" v-else>
      <span class="text-gray-800 leading-snug">{{ $t("users.no_friends_yet") }}</span>
      <div>
        <info :title="$t('users.adding_friends')" toggleable>
          {{
          $t("users.info_add_friends")
          }}
        </info>
      </div>
    </div>
    <fab v-if="!select" @input="toggleSearch">
      <icon name="Plus" />
    </fab>
  </div>
</template>

<script>
const Friend = require("@/modules/users/components/Friend.vue").default;
const Fab = require("@/modules/core/components/Fab.vue").default;
const Info = require("@/modules/core/components/Info.vue").default;

import FormMixin from "@/mixins/FormMixin";
import { User } from "@/modules/users/viewmodels/User";

export default {
  name: "FriendsSite",
  mixins: [FormMixin],
  data() {
    return {
      searchResult: [],
      searchVisible: false,
      selectedFriends: []
    };
  },
  props: {
    select: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array
    }
  },
  components: {
    Friend,
    Fab,
    Info
  },
  methods: {
    toggleSearch() {
      this.searchVisible = !this.searchVisible;

      if (this.searchVisible) {
        this.$store.dispatch("header/update", {
          clear: true,
          bg: "bg-secondary-500",
          elements: [
            {
              location: "left",
              type: "icon",
              value: "Back",
              action: () => {
                this.toggleSearch();
              }
            },
            {
              value: "Suche",
              css: "font-medium tracking-wider"
            }
          ]
        });
      } else {
        this.$store.dispatch("header/reset");
      }
    },
    emitClose() {
      this.$emit("close", this.selectedFriends);
    },
    storeFriend(Input) {
      if (Input.checked) {
        if (this.selectedFriends.indexOf(Input.friend) === -1) {
          this.selectedFriends.push(Input.friend);
        }
      } else {
        this.selectedFriends = this.selectedFriends.filter(
          e => e.id !== Input.friend.id
        );
      }
    }
  },
  computed: {
    friends() {
      let userFriends = this.$store.getters["userfriend/userFriends"];
      return userFriends ? userFriends.map(e => e.friend) : false;
    },
    incomingFriendRequests() {
      return this.$store.getters["userfriendrequest/incomingFriendRequests"];
    },
    outgoingFriendRequests() {
      return this.$store.getters["userfriendrequest/outgoingFriendRequests"];
    }
  },
  async created() {
    this.formOptions = {
      custom: true,
      async: true,
      type: "users",
      call: "search",
      action: response => {
        this.searchResult = response;
      }
    };
    if (!this.select) {
      this.$store.dispatch("header/update", {
        elements: [
          {
            type: "icon",
            value: "WaldigLogo",
            location: "left",
            iconSettings: { size: "1.8em", circle: true },
            action: () => {}
          },
          {
            type: "text",
            css: "tracking-wider",
            value: this.$t("users.friends"),
            location: "left"
          }
        ]
      });
    } else {
      this.$store.dispatch("header/update", {
        clear: true,
        elements: [
          {
            type: "icon",
            value: "Accept",
            location: "right",
            action: () => {
              this.emitClose();
            }
          }
        ]
      });
    }
    await this.$store.getters["userfriend/api"].Custom.My();
    await this.$store.getters["userfriendrequest/api"].Custom.Incoming();
    await this.$store.getters["userfriendrequest/api"].Custom.Outgoing();
    if (this.selected && this.selected.length > 0) {
      this.selected.forEach(e => {
        let foundFriend = this.friends.find(f => f.id === e);
        foundFriend.checked = true;
      });
    }
    this.loading = false;
  }
};
</script>
